import React from 'react';
import { Text } from '../../Text';
import moment from 'moment';

export interface SlotLabelProps {
  date: Date;
}

/**
 * Renders the time column on the left side
 */
export const CalendarSlotLabel: React.FC<SlotLabelProps> = ({ date }) => (
  <Text
    size="xs"
    weight="normal"
    variant="timestamp"
  >
    {moment(date, 'YYYY-MM-DD[T]h:mmAZ').format('HH:00')}
  </Text>
);
